import type { OnInit } from '@angular/core';
import type { FormControl } from '@angular/forms';

import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { CommonElementsModule } from '@web/widgets/common/common-elements.module';

@Component({
    selector: 'web-code-modal',
    templateUrl: './code-modal.component.html',
    styleUrls: ['./code-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule],
})
export class CodeModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);
    private readonly fb = inject(NonNullableFormBuilder);

    @Input() public content!: string;
    public onClose: Subject<string>;

    public contentControl: FormControl = this.fb.control(null);

    public ngOnInit(): void {
        this.onClose = new Subject();
        this.contentControl.setValue(this.content);
    }

    public onConfirm(): void {
        this.onClose.next(this.contentControl.value);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(null);
        this.bsModalRef.hide();
    }

    public onCloseModal(): void {
        this.bsModalRef.hide();
    }
}
